import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d8902db6 = () => interopDefault(import('../../../src/pages/Accordion.vue' /* webpackChunkName: "pages/Accordion" */))
const _88b4e6b8 = () => interopDefault(import('../../../src/pages/AccordionMenu.vue' /* webpackChunkName: "pages/AccordionMenu" */))
const _764a0910 = () => interopDefault(import('../../../src/pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _39604c4e = () => interopDefault(import('../../../src/pages/DrilldownMenu.vue' /* webpackChunkName: "pages/DrilldownMenu" */))
const _c6721778 = () => interopDefault(import('../../../src/pages/Dropdown.vue' /* webpackChunkName: "pages/Dropdown" */))
const _41ebf043 = () => interopDefault(import('../../../src/pages/DropdownMenu.vue' /* webpackChunkName: "pages/DropdownMenu" */))
const _2a1d0cd7 = () => interopDefault(import('../../../src/pages/form.vue' /* webpackChunkName: "pages/form" */))
const _ead54344 = () => interopDefault(import('../../../src/pages/Logo.vue' /* webpackChunkName: "pages/Logo" */))
const _7865af52 = () => interopDefault(import('../../../src/pages/Magellan.vue' /* webpackChunkName: "pages/Magellan" */))
const _a4f684b2 = () => interopDefault(import('../../../src/pages/Orbit.vue' /* webpackChunkName: "pages/Orbit" */))
const _f55db680 = () => interopDefault(import('../../../src/pages/Reveal.vue' /* webpackChunkName: "pages/Reveal" */))
const _134c0bd4 = () => interopDefault(import('../../../src/pages/Slider.vue' /* webpackChunkName: "pages/Slider" */))
const _4690aa9e = () => interopDefault(import('../../../src/pages/Tabs.vue' /* webpackChunkName: "pages/Tabs" */))
const _e384a8c0 = () => interopDefault(import('../../../src/pages/Tooltip.vue' /* webpackChunkName: "pages/Tooltip" */))
const _e5df2f20 = () => interopDefault(import('../../../src/pages/blog/author/_author.vue' /* webpackChunkName: "pages/blog/author/_author" */))
const _affcf190 = () => interopDefault(import('../../../src/pages/blog/page/_page.vue' /* webpackChunkName: "pages/blog/page/_page" */))
const _6027a20c = () => interopDefault(import('../../../src/pages/blog/tag/_tag.vue' /* webpackChunkName: "pages/blog/tag/_tag" */))
const _79b74ba0 = () => interopDefault(import('../../../src/pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _ffb67b62 = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-exact-active',
  scrollBehavior,

  routes: [{
    path: "/Accordion",
    component: _d8902db6,
    name: "Accordion"
  }, {
    path: "/AccordionMenu",
    component: _88b4e6b8,
    name: "AccordionMenu"
  }, {
    path: "/blog",
    component: _764a0910,
    name: "blog"
  }, {
    path: "/DrilldownMenu",
    component: _39604c4e,
    name: "DrilldownMenu"
  }, {
    path: "/Dropdown",
    component: _c6721778,
    name: "Dropdown"
  }, {
    path: "/DropdownMenu",
    component: _41ebf043,
    name: "DropdownMenu"
  }, {
    path: "/form",
    component: _2a1d0cd7,
    name: "form"
  }, {
    path: "/Logo",
    component: _ead54344,
    name: "Logo"
  }, {
    path: "/Magellan",
    component: _7865af52,
    name: "Magellan"
  }, {
    path: "/Orbit",
    component: _a4f684b2,
    name: "Orbit"
  }, {
    path: "/Reveal",
    component: _f55db680,
    name: "Reveal"
  }, {
    path: "/Slider",
    component: _134c0bd4,
    name: "Slider"
  }, {
    path: "/Tabs",
    component: _4690aa9e,
    name: "Tabs"
  }, {
    path: "/Tooltip",
    component: _e384a8c0,
    name: "Tooltip"
  }, {
    path: "/blog/author/:author?",
    component: _e5df2f20,
    name: "blog-author-author"
  }, {
    path: "/blog/page/:page?",
    component: _affcf190,
    name: "blog-page-page"
  }, {
    path: "/blog/tag/:tag?",
    component: _6027a20c,
    name: "blog-tag-tag"
  }, {
    path: "/blog/:slug",
    component: _79b74ba0,
    name: "blog-slug"
  }, {
    path: "/",
    component: _ffb67b62,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
